/** 404 for unknown routes. Keeps the user inside the product with real exits. */
import { Link, useLocation } from 'react-router-dom';

import { ROUTES } from '../lib/constants';

export function NotFoundPage(): JSX.Element {
  const { pathname } = useLocation();
  return (
    <div className="auth">
      <div className="auth__panel">
        <h1 className="auth__title">That page does not exist</h1>
        <p className="muted">
          Nothing is served at <span className="mono">{pathname}</span>. If you followed a team
          portal link, check the team code with your Team Admin.
        </p>
        <Link className="btn btn--primary btn--block" to={ROUTES.landing}>
          Go to the home page
        </Link>
        <Link className="btn btn--secondary btn--block" to={ROUTES.login}>
          Sign in
        </Link>
      </div>
    </div>
  );
}
